import { connect } from 'react-redux';
import SubscriptionCommitButton from '../components/SubscriptionCommitButton';

export default connect()(SubscriptionCommitButton);
